import requests from "./requests";
import qs from 'qs'
// import mockRequests from "./mockRequests";
//登录的接口:请求体携带参数 phone&&password
// export const reqUserLogin = (data)=>{
//     //requests({url:`api.php?op=vote_review&act=login`,method:'post',data});
//     console.log('login request');
//     return mockRequests({url:`/login`,method:'post',data});
// };

export const reqInit = (data, params)=>{
    return requests({
        method: 'post',
        url: '?mod=learn&con=hbrb&act=init',//查询活动信息
        data: qs.stringify(data),
        params: data 
    })
}

export const reqExplain = (data, params)=>{
    return requests({
        method: 'post',
        url: '?mod=learn&con=hbrb&act=explain',//查询活动信息
        data: qs.stringify(data),
        params: data 
    })
}

export const reqIsReg = (data, params)=>{
    return requests({
        method: 'post',
        url: '?mod=learn&con=hbrb&act=isreg',//查询用户是否登记
        data: qs.stringify(data),
        params: data 
    })
}

export const reqAdd = (data, params)=>{
    return requests({
        method: 'post',
        url: '?mod=learn&con=hbrb&act=add',//新增用户登记信息
        data: qs.stringify(data),
        params: data 
    })
}

export const reqEdit = (data, params)=>{
    return requests({
        method: 'post',
        url: '?mod=learn&con=hbrb&act=edit',//修改用户登记信息
        data: qs.stringify(data),
        params: data 
    })
}

export const reqLine = (data, params)=>{
    return requests({
        method: 'post',
        url: '?mod=learn&con=hbrb&act=line',//设置观看时间线
        data: qs.stringify(data),
        params: params 
    })
}

export const reqScore = (data, params)=>{
    return requests({
        method: 'post',
        url: '?mod=learn&con=hbrb&act=score',//观看完成，增加积分
        data: qs.stringify(data),
        params: params 
    })
}

export const reqUserInfo = (data, params)=>{
    return requests({
        method: 'post',
        url: '?mod=learn&con=hbrb&act=userinfo',//用户基本信息
        data: qs.stringify(data),
        params: params 
    })
}

export const reqRegInfo = (data, params)=>{
    return requests({
        method: 'post',
        url: '?mod=learn&con=hbrb&act=reginfo',//用户登记信息
        data: qs.stringify(data),
        params: params 
    })
}

//箭头函数只有一句 可以去掉{}和return
export const reqBannerList = (data) => requests({ url: '/banner', method: 'get', data });
